import React from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt } from 'react-icons/fa';
import './StudioSection.css';

const StudioSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="studio-section">
      <div className="container">
        <div className="home-section-header">
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <FaMapMarkerAlt />
            Visit Our Studio
          </motion.h2>

          <motion.p
            className="section-subtitle"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            style={{ margin: 0 }}
          >
            Come see where the magic happens
          </motion.p>
        </div>
        <div className="studio-content">
          <motion.div
            className="map-container"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="map-embed-wrapper">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.5!2d72.5714!3d23.0225!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xfa0897ddb7131f18!2sHandmade%20haven%20-%20Resin%20store!5e0!3m2!1sen!2sin!4v1234567890123!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Handmade Haven Studio Location"
                className="google-map-embed"
              ></iframe>
              <div className="map-overlay-link">
                <a
                  href="https://www.google.com/maps/place/Handmade+haven+-+Resin+store/data=!4m2!3m1!1s0x0:0xfa0897ddb7131f18?sa=X&ved=1t:2428&ictx=111"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-map"
                >
                  View on Google Maps
                </a>
              </div>
            </div>
          </motion.div>
          <motion.div
            className="studio-info"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="info-card">
              <div className="info-icon">
                <FaMapMarkerAlt />
              </div>
              <h3>Our Address</h3>
              <p>Handmade Haven Studio<br />By Muskan Kazi</p>
              <div className="info-buttons">
                <motion.a
                  href="https://www.google.com/maps/place/Handmade+haven+-+Resin+store/data=!4m2!3m1!1s0x0:0xfa0897ddb7131f18?sa=X&ved=1t:2428&ictx=111"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                  whileHover={{ scale: 1.05, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Get Directions
                </motion.a>
                <motion.a
                  href="#contact"
                  onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}
                  className="btn btn-primary"
                  whileHover={{ scale: 1.05, y: -3 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Visit Us
                </motion.a>
              </div>
              <p className="info-note">Open by appointment - DM us to schedule a visit</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default StudioSection;

